export enum NavigationPath {
    HOME = "/",
    AUTH = "/authorization",
    NEW_PASS = "/setnewPassword",
    INACTIVE_ACCOUNT = "/inactive",
    UNAVAILABLE = "/unavailable",
    DRIVER_APP_MESSAGE = "/driver/app",
    //client
    CLIENT_DASHBOARD = "/client/dashboard",
    CLIENT_ORDERS = "/client/orders",
    CLIENT_RECEPTION_PLACES = "/client/receptionPlaces",
    CLIENT_USERS = "/client/users",
    //orders
    ALL_ORDERS = "/orders/all",
    NEW_ORDERS = "/orders/new",
    ACCEPTED_ORDERS = "/orders/accepted",
    IN_PROGRESS_ORDERS = "/orders/in-progress",
    COMPLETED_ORDERS = "/orders/completed",
    INVOICED_ORDERS = "/orders/invoiced",
    CANCELED_ORDERS = "/orders/canceled",
    //validators
    CONTAINERS_VALIDATORS = "/validators/ContainersValidation",
    RECEPTION_PLACES_VALIDATORS = "/validators/receptionPlacesValidation",
    ORDERS_VALIDATORS = "/validators/ordersValidation",
    //price list
    DETAILED_PRICE_LIST = "/priceList/detailedPriceList",
    GENERAL_PRICE_LIST = "/priceList/generalPriceList",
    //clients
    UNVERIFIED_CLIENTS = "/clients/unverified",
    // NEW_CLIENTS="/clients/new",
    ACTIVE_CLIENTS = "/clients/active",
    INACTIVE_CLIENTS = "/clients/inactive",
    RECEPTION_PLACES = "/clients/receptionPlaces",
    UNACTIVE_USERS = "/users/inactive",
    UNACTIVE_PICKUP_POINTS = "/pickuppoints/inactive",
    //config
    ORDER_TYPES = "/config/orderTypes",
    VEHICLES = "/config/vehicles",
    DRIVERS = "/config/drivers",
    OPERATORS = '/config/operators',
    CANCELLATION_REASONS = '/config/cancellationReasons',
    VALIDATOR_TYPES = "/config/validatorTypes",
    NOT_CONFIRMED_USERS = "/config/notConfirmedUsers",
    ADMINS = `/config/admins`,
    //temp
    TEMP = "/TEMP",
    //report
    REPORT_LIST = "/report/reportList",
    //warehouse
    STORE_LIST = "/store/list",
    INTERALSTORE_LIST = "/internalstore/list",
    CONTAINERS_LIST = "/store/containers",
    STORE_DOCS_LIST = "/store/docs",
    STORE_MAP = "/store/map",
    STORE_CONTAINER_MAP = "/store/container/map"
}